"use strict";
// Copyright © 2021 Move Closer
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeduplicatedSetDriver = void 0;
const contracts_1 = require("../contracts");
const set_1 = require("./set");
/**
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
class DeduplicatedSetDriver extends set_1.SetDriver {
    constructor() {
        super(...arguments);
        /**
         * Key that stores RelatedType.
         * @protected
         */
        this.typeKey = contracts_1.RelatedType.DeduplicatedSet;
    }
}
exports.DeduplicatedSetDriver = DeduplicatedSetDriver;
//# sourceMappingURL=deduplicated.js.map